export default {
  namespaced: true,

  getters: {
    getPaymentTypeMode: (state, getters, rootState, rootGetters) => id => {
      const { Riconducibille, Privata, Sociale } = rootGetters['apis/getObj']({ id, key: 'paymentTypes' })
      if (Riconducibille === '1') return 'Riconducibile'
      if (Privata === '1') return 'Privato'
      if (Sociale === '1') return 'Sociale'
      return ''
    },
  },
}
